import { render } from "./PartnerKlarna.vue?vue&type=template&id=3e33c8d6"
import script from "./PartnerKlarna.vue?vue&type=script&lang=js"
export * from "./PartnerKlarna.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__